import * as Yup from 'yup';

export const personalInfoValidationSchema = () =>
  Yup.object().shape({
    demographics: Yup.object().shape({
      maritalStatus: Yup.string().required('Please select a marital status.'),
      ethnicity: Yup.string().required('Please select an ethnicity.'),
      races: Yup.array().required('Please select a race.'),
      religion: Yup.string().required('Please select a religious preference.'),
      primaryLanguage: Yup.string().required('Please select a preferred language.')
    }),
    emails: Yup.array().of(
      Yup.object().shape({
        address: Yup.string().when('emails', {
          is: val => val?.type === 'HOMEEMAIL',
          then: Yup.string().required('Please provide a valid email address.')
        })
      })
    ),
    phones: Yup.array().of(
      Yup.object().shape({
        areaCode: Yup.string()
          .notRequired()
          .when('phones', {
            is: val => val?.type === 'CELLPHONE',
            then: Yup.string()
              .matches(/^[0-9]{3}$/, 'Phone must match format (XXX)')
              .required('Please select provide a valid area code.')
          }),

        phoneNumber: Yup.string()
          .notRequired()
          .when('phones', {
            is: val => val?.type === 'CELLPHONE',
            then: Yup.string()
              .matches(/^[0-9]{7}$/, 'Phone must match format XXX XXXX')
              .required('Please select provide a valid phone number.')
          })
      })
      // TODO: Preferred phone number is not yet a feature needed yet. When it gets added in then we will need to check as it is a required field.
    ),
    addresses: Yup.array().of(
      Yup.object().shape({
        address1: Yup.string().required('Please provide an address.'),
        city: Yup.string().required('Please provide a city for an address.'),
        state: Yup.string().required('Please provide a state for an address.'),
        zip: Yup.string().required('Please provide zip code for an address.')
      })
    ),
    // Start of the additional contact fields
    // TODO: Additional Contact section does not yet exist in live version so once that is added to the GQL then it will need proper validation for required fields

    additionalCheckBoxApproval: Yup.bool()
      .notRequired()
      .when('addAdditionalContact', {
        is: 'Yes',
        then: Yup.bool().oneOf([true], 'Accept Terms & Conditions is required')
      }),

    additionalFirstName: Yup.string()
      .notRequired()
      .when('addAdditionalContact', {
        is: 'Yes',
        then: Yup.string()
          .required('Please enter a valid first name.')
          .max(20, 'Name should not be more than 20 characters')
      }),
    additionalLastName: Yup.string()
      .notRequired()
      .when('addAdditionalContact', {
        is: 'Yes',
        then: Yup.string()
          .required('Please enter a valid first name.')
          .max(20, 'Name should not be more than 20 characters')
      }),
    additionalRelationshipToPatient: Yup.string()
      .notRequired()
      .when('addAdditionalContact', {
        is: 'Yes',
        then: Yup.string()
          .required('Please enter your relationship to the patient.')
          .max(20, 'Relationship to the patient should be no more than 20 characters')
      }),
    additionalPhoneNumber: Yup.string()
      .notRequired()
      .when('addAdditionalContact', {
        is: 'Yes',
        then: Yup.string().notRequired()
      })
  });
